<template>
  <div class="fileinput text-center">
    <div
      class="fileinput-new thumbnail"
      :class="{ 'img-circle': type === 'avatar' }"
    >
      <img class="img-fluid shadow border-radius-lg" :src="image" alt="preview" />
    </div>
    <div>
      <span v-if="!fileExists" class="btn mb-0 btn-dark file-input-wrapper">
        <span class="fileinput-new">{{ fileExists ? uploadText : selectText }}</span>
        <input
          type="file"
          name="..."
          class="valid"
          :multiple="false"
          aria-invalid="false"
          @change="handlePreview"
        />
      </span>
      <material-button v-if="fileExists && showUploadButton" variant="outline" color="success" size="sm" class="image-button" @click="uploadFile">
        <i class="fas fa-upload"></i> {{ $t('image.upload') }}
      </material-button>
      <material-button v-if="fileExists" variant="outline" color="primary" size="sm" class="image-button" @click="removeFile">
        <i class="fas fa-times"></i> {{ $t('image.remove') }}
      </material-button>
    </div>
  </div>
</template>
<script>
import imageCompression from 'browser-image-compression';
import MaterialButton from './MaterialButton.vue';

export default {
  name: 'ImageUpload',
  components: {
    MaterialButton
  },
  props: {
    type: {
      type: String,
      default: '',
      description: 'Image upload type (""|avatar)'
    },
    src: {
      type: String,
      default: '',
      description: 'Initial image to display'
    },
    selectText: {
      type: String,
      default: 'Select image'
    },
    uploadText: {
      type: String,
      default: 'Upload'
    },
    removeText: {
      type: String,
      default: 'Remove'
    },
    base64Image: {
      type: String,
      default: '',
      description: 'Base64 string of the image'
    },
    showUploadButton: {
      type: Boolean,
      default: true,
      description: 'Control if upload button should be showed'
    }
  },
  emits: ['change', 'upload'],
  data() {
    let avatarPlaceholder = 'img/placeholder.jpg';
    let imgPlaceholder = 'img/image_placeholder.jpg';
    return {
      placeholder: this.type === 'avatar' ? avatarPlaceholder : imgPlaceholder,
      imagePreview: null
    };
  },
  computed: {
    fileExists() {
      return this.imagePreview !== null;
    },
    image() {
      return this.imagePreview || this.src || this.placeholder;
    }
  },
  created() {
    if (this.base64Image) {
      // Convert base64 to Blob
      let byteCharacters = atob(this.base64Image);
      let byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      let blob = new Blob([byteArray], {type: "image/png"});
      // Create URL representing the image
      this.imagePreview = URL.createObjectURL(blob);
    }
  },
  methods: {
    async handlePreview(event) {
      let file = event.target.files[0];
      // Compress the image
      let options = {
        maxSizeMB: 1,          // (default: Number.POSITIVE_INFINITY)
        maxWidthOrHeight: 1920,  // (default: undefined)
        useWebWorker: true,      // (default: true)
      };
      try {
        const compressedFile = await imageCompression(file, options);
        this.imagePreview = URL.createObjectURL(compressedFile);
        this.$emit('change', compressedFile); // Emit the compressed file instead of the original file
      } catch (error) {
        console.log(error); // eslint-disable-line no-console
      }
    },
    removeFile() {
      this.imagePreview = null;
      this.$emit('change', null);
    },
    uploadFile() {
      this.$emit('upload', this.imagePreview);
      this.imagePreview = null;
    }
  }
};
</script>
<style scoped>
.file-input-wrapper {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  margin-top: 5px;
}

.file-input-wrapper input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.image-button {
  margin: 5px;
  min-width: 50px;
}

.fileinput {
  max-width: 300px;
}
</style>